import {Link} from 'react-router';

export default function AmazonV1UpgradeNotice({compact=false}: {compact?: boolean}) {
  return <section role="alert" className={`rounded-2xl border border-amber-200 bg-amber-50 ${compact ? 'p-4' : 'p-6'} space-y-3`}>
    <h2 className="font-semibold text-slate-950">Amazon bağlantınızı V2’ye güncelleyin</h2>
    <p className="text-sm leading-6 text-slate-700">Amazon V1 artık yeni sipariş almıyor. Siparişlerinizi almaya devam etmek için Amazon hesabınızı V2’ye bağlayın.</p>
    <Link className="inline-flex rounded-xl bg-slate-950 px-4 py-2.5 text-sm font-semibold text-white" to="/customer/stores/amazon-v2/new">Amazon V2’ye bağlan</Link>
  </section>;
}
